import React from 'react';
import { useTranslation } from '@/lib/i18n';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const LanguageTest = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-foreground">Language Test</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>{t('common.save')} & {t('common.cancel')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <p><strong>Dashboard:</strong> {t('nav.dashboard')}</p>
              <p><strong>Orders:</strong> {t('nav.orders')}</p>
              <p><strong>Customers:</strong> {t('nav.customers')}</p>
              <p><strong>Total Orders:</strong> {t('dashboard.todayOrders')}</p>
              <p><strong>Create Order:</strong> {t('orders.newOrder')}</p>
            </div>
            <div className="flex gap-2">
              <Button>{t('common.save')}</Button>
              <Button variant="outline">{t('common.cancel')}</Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>{t('header.language')}</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <p><strong>Vietnamese:</strong> {t('header.vietnamese')}</p>
              <p><strong>English:</strong> {t('header.english')}</p>
              <p><strong>Profile:</strong> {t('header.profile')}</p>
              <p><strong>Logout:</strong> {t('header.logout')}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LanguageTest; 